import { Card, CardBody, CardTitle } from "reactstrap";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

interface Props {
  type: "month" | "year";
  selectedMonth: number;
  selectedYear: number;
  parsedCosts: any;
}

const CostGraph = ({
  type,
  selectedMonth,
  selectedYear,
  parsedCosts,
}: Props) => {
  return (
    <Card className="shadow border-sm h-100 bg-white">
      <CardTitle className=" mt-3 ml-4">
        <div className="w-100">
          <div className="w-100 d-flex">
            <h3 className="w-50">
              {`Usage ${
                type === "month"
                  ? new Date(
                      `${selectedYear}-${selectedMonth + 1}-01`
                    ).toLocaleString("default", {
                      month: "long",
                    })
                  : selectedYear
              } (USD)`}
            </h3>
          </div>
          <p className="h2">${getTotalCost(parsedCosts)}</p>
        </div>
      </CardTitle>
      <CardBody
        style={{ minHeight: "300px" }}
        className="flex justify-content-center"
      >
        <ResponsiveContainer minHeight={"200px"} width={"100%"} height={"100%"}>
          <BarChart data={parsedCosts}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey={type === "month" ? "Owner" : "Month"} />
            <YAxis />
            <Legend />
            <Tooltip />
            <Bar dataKey="gpt-4o-mini-graph" stackId="a" fill="#8884d8" />
          </BarChart>
        </ResponsiveContainer>
      </CardBody>
    </Card>
  );

  function getTotalCost(parsedCosts: Array<Record<string, number>>) {
    return parsedCosts
      .reduce((acc, curr) => {
        return acc + curr["gpt-4o-mini-graph"];
      }, 0)
      .toFixed(6);
  }
};

export default CostGraph;
